import {
  Tag,
  Star,
  MessageSquareReply,
  Share2,
  Search,
  Facebook,
  Mail,
  FileText,
  BookOpen,
} from 'lucide-react';

export const AI_TOOLS = [
  {
    id: 'brandproduct-descriptions',
    name: 'Brand/Product Descriptions',
    description: 'Generate detailed description for your brand or product.',
    icon: Tag,
    fields: [
      { key: 'name', label: 'Product / Brand Name', type: 'text', placeholder: 'e.g. Premium Wireless Headphones' },
      { key: 'description', label: 'Brief Description', type: 'textarea', placeholder: 'Describe the product or brand...' },
    ],
  },
  {
    id: 'product_review',
    name: 'Product Review Generator',
    description: 'Generate amazing reviews for products you like.',
    icon: Star,
    fields: [
      { key: 'name', label: 'Product Name', type: 'text', placeholder: 'e.g. Sony WH-1000XM5' },
      { key: 'description', label: 'Product Description', type: 'textarea', placeholder: 'What is the product about?' },
      { key: 'features_liked', label: 'Features You Liked', type: 'textarea', placeholder: 'e.g. noise cancellation, battery life...' },
    ],
  },
  {
    id: 'review_response',
    name: 'Review Response',
    description: 'Generate professional responses to customer reviews.',
    icon: MessageSquareReply,
    fields: [
      { key: 'customer_review', label: 'Customer Review', type: 'textarea', placeholder: 'Paste the customer review here...' },
    ],
  },
  {
    id: 'social_post',
    name: 'Social Media Post',
    description: 'Create engaging social media posts for your business.',
    icon: Share2,
    fields: [
      { key: 'description', label: 'What to post about?', type: 'textarea', placeholder: 'Describe what you want to post about...' },
    ],
  },
  {
    id: 'google-ads',
    name: 'Google Ads',
    description: 'Create ads that convert more customers on Google.',
    icon: Search,
    fields: [
      { key: 'name', label: 'Product / Service Name', type: 'text', placeholder: 'e.g. Cloud Storage Service' },
      { key: 'description', label: 'Description', type: 'textarea', placeholder: 'Describe your product or service...' },
    ],
  },
  {
    id: 'fb-ads',
    name: 'Facebook Ads',
    description: 'Generate headline & text for Facebook posts and ads.',
    icon: Facebook,
    fields: [
      { key: 'name', label: 'Product / Service Name', type: 'text', placeholder: 'e.g. Online Fitness Course' },
      { key: 'description', label: 'Description', type: 'textarea', placeholder: 'Describe your product or service...' },
    ],
  },
  {
    id: 'email',
    name: 'Email',
    description: 'Write professional emails that impress and get replies.',
    icon: Mail,
    fields: [
      { key: 'sender', label: 'Sender Name', type: 'text', placeholder: 'e.g. John Smith' },
      { key: 'recipient', label: 'Recipient Name', type: 'text', placeholder: 'e.g. Jane Doe' },
      { key: 'email_about', label: 'Email About', type: 'textarea', placeholder: 'What is this email about?' },
    ],
    hasTone: true,
  },
  {
    id: 'proposal',
    name: 'Proposal',
    description: 'Create compelling B2B proposals to win new clients.',
    icon: FileText,
    fields: [
      { key: 'what_biz_does', label: 'What Does Your Business Do?', type: 'textarea', placeholder: 'Describe your business...' },
      { key: 'what_do_for_client', label: 'What Will You Do For The Client?', type: 'textarea', placeholder: 'Describe what you offer to the client...' },
    ],
  },
  {
    id: 'kb',
    name: 'Knowledge Base',
    description: 'A step-by-step guide for doing anything.',
    icon: BookOpen,
    fields: [
      { key: 'kb_details', label: 'Knowledge Base Details', type: 'textarea', placeholder: 'Describe what the knowledge base article should cover...' },
    ],
  },
];

export const LANGUAGES = [
  { value: 'English', label: 'English' },
  { value: 'Arabic', label: 'Arabic' },
  { value: 'French', label: 'French' },
  { value: 'Spanish', label: 'Spanish' },
  { value: 'German', label: 'German' },
  { value: 'Hindi', label: 'Hindi' },
  { value: 'Urdu', label: 'Urdu' },
];

export const TONES = [
  { value: 'polite', label: 'Polite' },
  { value: 'persuasive', label: 'Persuasive' },
  { value: 'professional', label: 'Professional' },
  { value: 'casual', label: 'Casual' },
  { value: 'witty', label: 'Witty' },
];
